import { ArrowLeft } from 'lucide-react';
import { LandingNavbar } from '../LandingNavbar';
import { BottomNavigation } from '../BottomNavigation';

interface AccountLayoutProps {
  children: React.ReactNode;
  title: string;
  subtitle?: string;
  onBack?: () => void;
  activePage?: 'home' | 'booking' | 'support' | 'account';
  onHomeClick?: () => void;
  onMyTripsClick?: () => void;
  onAccountClick?: () => void;
  onProfileClick?: () => void;
  onMyTicketsClick?: () => void;
  onSettingsClick?: () => void;
  onLogoutClick?: () => void;
  isLoggedIn?: boolean;
  onLoginClick?: () => void;
  showBottomNav?: boolean;
  showMobileHeader?: boolean;
}

export const AccountLayout = ({
  children,
  title,
  subtitle,
  onBack,
  activePage = 'account',
  onHomeClick,
  onMyTripsClick,
  onAccountClick,
  onProfileClick,
  onMyTicketsClick,
  onSettingsClick,
  onLogoutClick,
  isLoggedIn,
  onLoginClick,
  showBottomNav = true,
  showMobileHeader = true,
}: AccountLayoutProps) => {
  return (
    <div className="min-h-screen bg-[#F7F8FA]">
      {/* Desktop Navbar */}
      <LandingNavbar 
        className="hidden lg:block"
onLogoClick={onBack ?? onHomeClick ?? (() => {})}
        isLoggedIn={isLoggedIn}
        userName="Ana García"
        onProfileClick={onProfileClick}
        onMyTicketsClick={onMyTicketsClick}
        onSettingsClick={onSettingsClick}
        onLogoutClick={onLogoutClick}
        onLoginClick={onLoginClick}
      />

      {/* Mobile Header */}
      {showMobileHeader && (
        <div className="lg:hidden bg-white border-b border-[#E5E7EB] sticky top-0 z-10">
          <div className="flex items-center gap-3 p-4">
            {onBack && (
              <button
                onClick={onBack}
                className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-[#F7F8FA] transition-colors"
              >
                <ArrowLeft className="w-6 h-6 text-[#111827]" />
              </button>
            )}
            <h1 className="text-lg font-bold text-[#111827]">{title}</h1>
          </div>
        </div>
      )}

      {/* Content */}
      <div className="max-w-[1440px] mx-auto p-4 lg:px-8 lg:py-8 pb-20 lg:pb-8">
        {/* Desktop Title */}
        {isLoggedIn && (
          <div className="hidden lg:block mb-6">
            <h1 className="text-3xl font-bold text-[#111827] mb-2">{title}</h1>
            {subtitle && <p className="text-[#6B7280]">{subtitle}</p>}
          </div>
        )}

        {/* Main Content */}
        {children}
      </div>

      {/* Bottom Navigation - Mobile Only */}
      {showBottomNav && (
        <BottomNavigation 
          activePage={activePage}
          onHomeClick={onHomeClick}
          onMyTripsClick={onMyTripsClick}
          onAccountClick={onAccountClick}
        />
      )}
    </div>
  );
};